/*
 * @Description:
 * @Date: 2020-07-19 15:20:21
 */
import { BI } from '@/api/ajax';
import { percentage } from '@/tools/index';
import {
  createBarSeries,
  createBarCircleSeries,
  createLineSeries,
  createMapSeries
} from '../components/Echarts/echartOption';
import { axisFormatter, dealProvince, dealTips } from '../tools/index';

const dealCount = (obj = {}, unit) => {
  const finalDataCount = Object.entries(obj).reduce((pre, cur) => {
    pre += cur[1];
    return pre;
  }, 0);
  return Object.entries(obj).reduce(
    (pre, cur) => {
      const [key, value] = cur;
      pre.xAxisData.push(key);
      pre.series0data.push({
        value: value,
        name: key,
        b: value + unit
      });
      pre.data.push({
        d: key,
        v: value,
        b: percentage(value, finalDataCount)
      });
      return pre;
    },
    {
      data: [], // 表格数据
      xAxisData: [], // x轴
      series0data: [], // 图表数据
      count: finalDataCount
    }
  );
};

const getMoudle = (
  obj = {},
  chartType,
  nameInfo = {
    moudleTitle: '',
    targetTitle: '',
    name: '',
    axisName: '',
    axisName2: '',
    unit: '',
    useSpecialCount: false,
    specialCount: 0
  },
  hideHeader = true
) => {
  const {
    moudleTitle,
    targetTitle,
    name,
    axisName,
    axisName2,
    unit,
    useSpecialCount,
    specialCount
  } = nameInfo;
  const { data, xAxisData, series0data, count } = dealCount(obj, unit);
  let chartInfo = {};
  switch (chartType) {
    case 'bar2':
      chartInfo = {
        echartType: 'bar2',
        echartStyle: {
          height: `${Math.max(count * 55, 400)}px`
        },
        echartOption: {
          tooltip: {
            formatter: function(params) {
              const { axisValue, value } = params[0] || params || {};
              return dealTips(axisValue, value, unit);
            }
          },
          xAxis: {
            nameTextStyle: {
              color: '#E0E0E0',
              padding: [30, 0, 0, -5]
            },
            data: xAxisData,
            name: `${axisName2 || name + '名称'}`,
            axisLabel: {
              interval: 0,
              textStyle: {
                color: '#666',
                fontSize: 11,
                lineHeight: 18
              },
              formatter: function(params) {
                return axisFormatter(params, xAxisData.length);
              }
            }
          },
          yAxis: {
            name: `${axisName || name + '数量'}（${unit}）`
          },
          series: createBarSeries(series0data, true)
        }
      };
      break;
    case 'bar3':
      chartInfo = {
        echartType: 'bar3',
        echartOption: {
          tooltip: {
            formatter: function(params) {
              const { axisValue, value } = params[0] || params || {};
              return dealTips(axisValue, value, unit);
            }
          },
          xAxis: {
            nameTextStyle: {
              color: '#E0E0E0',
              padding: [30, 0, 0, -5]
            },
            name: `${axisName2 || name + '名称'}`,
            data: xAxisData,
            axisLabel: {
              interval: 0,
              textStyle: {
                color: '#666',
                fontSize: 11,
                lineHeight: 18
              },
              formatter: function(params) {
                return axisFormatter(params, xAxisData.length);
              }
            }
          },
          yAxis: {
            name: `${axisName || name + '数量'}（${unit}）`
          },
          series: createBarCircleSeries(series0data, true)
        }
      };
      break;
    case 'bar':
      chartInfo = {
        echartType: 'bar',
        echartOption: {
          tooltip: {
            formatter: function(params) {
              const { axisValue, value } = params[0] || params || {};
              return dealTips(axisValue, value, unit);
            }
          },
          xAxis: {
            nameTextStyle: {
              color: '#E0E0E0',
              padding: [30, 0, 0, -5]
            },
            name: `${axisName || name + '数量'}（${unit}）`
          },
          yAxis: {
            data: xAxisData,
            name: `${axisName2 || name + '名称'}`
          },
          series: createBarSeries(series0data)
        }
      };
      break;
    case 'line':
      chartInfo = {
        echartType: 'line',
        echartOption: {
          tooltip: {
            formatter: function(params) {
              const { axisValue, value } = params[0] || params || {};
              return dealTips(axisValue, value, unit);
            }
          },
          xAxis: {
            type: 'category',
            data: xAxisData,
            name: `${axisName2 || name + '名称'}`,
            nameTextStyle: {
              color: '#E0E0E0',
              padding: [30, 0, 0, 0]
            },
            axisLabel: {
              interval: 0
            }
          },
          yAxis: {
            name: `${axisName || name + '数量'}（${unit}）`
          },
          series: createLineSeries(series0data)
        }
      };
      break;
  }
  const header = {
    index: 1,
    title: `${targetTitle}（目标题）`,
    isMustFill: true,
    name: moudleTitle || `${name}分布`,
    hideHeader
  };
  const tableHeader = [
    { label: `${axisName2 || name + '名称'}`, prop: 'd' },
    {
      label: `${axisName || name + '数量'}（${unit}）`,
      prop: 'v'
    },
    { label: '百分比(%)', prop: 'b' }
  ];
  if (chartType === 'custom') {
    return {
      key: 'targetType-custom',
      value: {
        header,
        customComponents: [
          {
            options: {
              table: {
                header: tableHeader,
                data: data,
                finalDataCount: count,
                isNormal: true
              },
              series0data: series0data,
              finalDataCount: useSpecialCount ? specialCount : count
            },
            com: require('../components/customCharts/pie3dType3').default
          }
        ]
      }
    };
  }
  if (chartType === 'blank') {
    return {
      key: 'targetType-custom' + new Date().getTime() + Math.random(),
      value: {
        header,
        customComponents: [
          {
            options: {
              series0data: obj,
              finalDataCount: obj.length
            },
            com: require('../components/customCharts/fillBlanks').default
          }
        ]
      }
    };
  }
  return {
    key: 'targetType-' + name + new Date().getTime(),
    value: {
      header: header,
      table: {
        header: tableHeader,
        data: data,
        finalDataCount: useSpecialCount ? specialCount : count
      },
      echart: [chartInfo]
    }
  };
};

const getMapMoudle = (
  obj = {},
  nameInfo = {
    moudleTitle: '',
    targetTitle: '',
    name: '',
    axisName: '',
    axisName2: '',
    unit: '',
    useSpecialCount: false,
    specialCount: 0
  },
  hideHeader = true
) => {
  const {
    moudleTitle,
    targetTitle,
    name,
    axisName,
    axisName2,
    unit,
    useSpecialCount,
    specialCount
  } = nameInfo;
  // const { data, series0data, count } = dealCount(obj, unit);
  const { finalData, finalDataCount } = obj;
  let data = [];
  let series0data = [];
  let mapData = {};
  finalData.forEach(item => {
    let provinceName = item.provinceName.replace(/省|市/g, '');
    mapData[provinceName] = mapData[provinceName]
      ? mapData[provinceName] + item.cc
      : item.cc;
    data.push({
      d: item.provinceName,
      v: item.cc,
      b: percentage(item.cc, finalDataCount)
    });
  });
  const maxLength = 6;
  const sData = data.sort((a, b) => a.v - b.v).reverse();
  const otherSum = sData.slice(maxLength).reduce((pre, cur) => {
    pre += cur.v;
    return pre;
  }, 0);
  data = sData.reduce((pre, cur, index) => {
    index < maxLength && pre.push(cur);
    return pre;
  }, []);
  if (otherSum > 0) {
    data = data.concat({
      d: '其他',
      v: otherSum,
      b: percentage(otherSum, finalDataCount)
    });
  }
  Object.entries(mapData).forEach(item => {
    series0data.push({
      name: item[0],
      value: item[1]
    });
  });
  return {
    key: 'querytaskHospitalDistribution' + new Date().getTime(),
    value: {
      header: {
        index: 1,
        isMustFill: true,
        name: moudleTitle || `${name}分布`,
        hideHeader
      },
      table: {
        header: [
          { label: `${axisName2 || name + '名称'}`, prop: 'd' },
          {
            label: `${axisName || name + '数量'}（${unit}）`,
            prop: 'v'
          },
          { label: '百分比(%)', prop: 'b' }
        ].map(item => {
          item['width'] = Math.max(`${item.label}`.length * 20, 100);
          return item;
        }),
        data,
        finalDataCount: useSpecialCount ? specialCount : finalDataCount,
        isNormal: true
      },
      useMapLayout: true,
      echart: [
        {
          echartType: 'map',
          echartStyle: { width: '630px', height: '450px' },
          echartOption: {
            series: createMapSeries(series0data, finalDataCount)
          }
        }
      ]
    }
  };
};

const getCountMoudle = (name, targetTitle, count, unit) => {
  return {
    key: 'targetTypeCountTitle-' + name + new Date().getTime(),
    value: {
      header: {
        name: `${name}数量：${count}${unit}`,
        title: `${targetTitle}（目标题）`,
        hideNoMore: true
      },
      echart: []
    }
  };
};

export default {
  // 医生拜访
  targetType1(info) {
    const {
      dutyNameCount,
      firstDepartmentNameCount,
      hospitalNameCount,
      customerCount,
      targetTitle
    } = info;
    return [
      getCountMoudle('医生', targetTitle, customerCount, '人'),
      getMoudle(hospitalNameCount, 'bar2', {
        targetTitle,
        name: '医院',
        axisName: '任务数',
        unit: '单'
      }),
      getMoudle(firstDepartmentNameCount, 'bar3', {
        targetTitle,
        name: '科室',
        axisName: '任务数',
        unit: '单'
      }),
      getMoudle(dutyNameCount, 'bar', {
        targetTitle,
        name: '职称',
        axisName: '任务数',
        unit: '单'
      })
    ];
  },
  // 等级医院医生
  targetType2(info) {
    const {
      dutyNameCount,
      firstDepartmentNameCount,
      hospitalNameCount,
      gradeNameCount,
      customerCount,
      targetTitle
    } = info;
    return [
      getCountMoudle('医生', targetTitle, customerCount, '人'),
      getMoudle(hospitalNameCount, 'bar2', {
        targetTitle,
        name: '医院',
        axisName: '任务数',
        unit: '单'
      }),
      getMoudle(firstDepartmentNameCount, 'bar3', {
        targetTitle,
        name: '科室',
        axisName: '任务数',
        unit: '单'
      }),
      getMoudle(dutyNameCount, 'bar', {
        targetTitle,
        name: '职称',
        axisName: '任务数',
        unit: '单'
      }),
      getMoudle(gradeNameCount, 'line', {
        targetTitle,
        name: '医院等级',
        axisName2: '等级名称',
        axisName: '任务数',
        unit: '单'
      })
    ];
  },
  // 基层医疗医生
  targetType3(info) {
    const {
      dutyNameCount,
      firstDepartmentNameCount,
      hospitalNameCount,
      gradeNameCount,
      customerCount,
      targetTitle
    } = info;
    return [
      getCountMoudle('医疗机构医生', targetTitle, customerCount, '人'),
      getMoudle(hospitalNameCount, 'bar2', {
        targetTitle,
        name: '医疗机构',
        axisName: '任务数',
        unit: '单'
      }),
      getMoudle(firstDepartmentNameCount, 'bar3', {
        targetTitle,
        name: '科室',
        axisName: '任务数',
        unit: '单'
      }),
      getMoudle(gradeNameCount, 'line', {
        targetTitle,
        name: '医疗机构类别',
        axisName2: '类别名称',
        axisName: '任务数',
        unit: '单'
      })
    ];
  },
  // 等级医院科室
  targetType6(info) {
    const {
      dutyNameCount,
      firstDepartmentNameCount,
      hospitalNameCount,
      gradeNameCount,
      customerCount,
      targetTitle
    } = info;
    return [
      getCountMoudle('等级医院科室', targetTitle, customerCount, '个'),
      getMoudle(hospitalNameCount, 'bar2', {
        targetTitle,
        name: '医院',
        axisName: '任务数',
        unit: '单'
      }),
      getMoudle(gradeNameCount, 'line', {
        targetTitle,
        name: '医院等级',
        axisName2: '等级名称',
        axisName: '任务数',
        unit: '单'
      }),
      getMoudle(firstDepartmentNameCount, 'bar3', {
        targetTitle,
        name: '科室',
        axisName: '任务数',
        unit: '单'
      })
    ];
  },
  // 医药商业公司客户
  targetType9(info) {
    const {
      jobTitleCount,
      fullNameCount,
      categoryCustomerCount,
      customerCount,
      targetTitle
    } = info;
    return [
      getCountMoudle('客户', targetTitle, customerCount, '人'),
      getMoudle(fullNameCount, 'bar2', {
        targetTitle,
        name: '客户',
        axisName: '任务数',
        unit: '单'
      }),
      getMoudle(jobTitleCount, 'bar3', {
        targetTitle,
        name: '职务',
        axisName: '任务数',
        unit: '单'
      }),
      getMapMoudle(categoryCustomerCount, {
        targetTitle,
        name: '医药商业公司客户',
        axisName2: '地名',
        axisName: '任务数',
        unit: '单'
      })
    ];
  },
  // 零售药店客户
  targetType10(info) {
    const {
      jobTitleCount,
      fullNameCount,
      categoryCustomerCount,
      customerCount,
      targetTitle
    } = info;
    return [
      getCountMoudle('客户', targetTitle, customerCount, '人'),
      getMoudle(fullNameCount, 'bar2', {
        targetTitle,
        name: '客户',
        axisName: '任务数',
        unit: '单'
      }),
      getMoudle(jobTitleCount, 'bar3', {
        targetTitle,
        name: '职务',
        axisName: '任务数',
        unit: '单'
      }),
      getMapMoudle(categoryCustomerCount, {
        targetTitle,
        name: '零售药店客户',
        axisName2: '地名',
        axisName: '任务数',
        unit: '单'
      })
    ];
  },
  // 零售药店
  targetType11(info) {
    const {
      fullNameCount,
      categoryCustomerCount,
      customerCount,
      targetTitle
    } = info;
    return [
      getCountMoudle('药店', targetTitle, customerCount, '家'),
      getMoudle(fullNameCount, 'bar2', {
        targetTitle,
        name: '药店',
        axisName: '任务数',
        unit: '单'
      }),
      getMapMoudle(categoryCustomerCount, {
        targetTitle,
        name: '零售药店',
        axisName2: '地名',
        axisName: '药店数量',
        unit: '家'
      })
    ];
  },
  // 医疗（医药）商业公司
  targetType12(info) {
    const {
      fullNameCount,
      categoryCustomerCount,
      customerCount,
      targetTitle
    } = info;
    return [
      getCountMoudle('公司', targetTitle, customerCount, '家'),
      getMoudle(fullNameCount, 'bar2', {
        targetTitle,
        name: '公司',
        axisName: '任务数',
        unit: '单'
      }),
      getMapMoudle(categoryCustomerCount, {
        targetTitle,
        name: '医疗（医药）商业公司',
        axisName2: '地名',
        axisName: '公司数量',
        unit: '家'
      })
    ];
  },
  // 患者
  targetType13(info) {
    const { ageCount, genderCount, targetTitle, customerCount } = info;
    return [
      getCountMoudle('患者', targetTitle, customerCount, '人'),
      getMoudle(
        {
          男性: genderCount.boyCount,
          女性: genderCount.girlCount
        },
        'bar',
        {
          targetTitle,
          name: '性别',
          unit: '人'
        }
      ),
      getMoudle(
        Object.entries({
          ageRange1Count: '18~30周岁',
          ageRange2Count: '31~40周岁',
          ageRange3Count: '41~50周岁',
          ageRange4Count: '51~70周岁',
          ageRange5Count: '70周岁以上'
        }).reduce((pre, cur) => {
          const [key, value] = cur;
          pre[value] = ageCount[key];
          return pre;
        }, {}),
        'custom',
        {
          targetTitle,
          name: '年龄',
          unit: '人'
        }
      )
    ];
  },
  // 等级医院
  targetType15(info) {
    const {
      targetTitle,
      categoryCustomerCount,
      detailAddresses,
      gradeNameCount,
      hospitalNameCount
    } = info;
    return [
      getCountMoudle(
        '等级医院',
        targetTitle,
        categoryCustomerCount.finalDataCount,
        '个'
      ),
      getMoudle(hospitalNameCount, 'bar2', {
        targetTitle,
        name: '医院',
        axisName: '任务数',
        unit: '单'
      }),
      getMoudle(gradeNameCount, 'line', {
        targetTitle,
        name: '医院等级',
        axisName2: '等级名称',
        axisName: '任务数',
        unit: '单'
      }),
      getMapMoudle(categoryCustomerCount, {
        targetTitle,
        name: '基层医疗机构',
        axisName2: '地名',
        axisName: '任务数',
        unit: '单'
      }),
      getMoudle(
        detailAddresses.reduce((pre, cur) => {
          pre.push({ d: cur });
          return pre;
        }, []),
        'blank',
        {
          targetTitle,
          moudleTitle: '详细地址'
        }
      )
    ];
  },
  // 基层
  targetType16(info) {
    const {
      targetTitle,
      categoryCustomerCount,
      detailAddresses,
      gradeNameCount,
      hospitalNames
    } = info;
    return [
      getCountMoudle(
        '基础医疗机构',
        targetTitle,
        categoryCustomerCount.finalDataCount,
        '个'
      ),
      getMoudle(gradeNameCount, 'line', {
        targetTitle,
        moudleTitle: '基层医疗机构类型',
        axisName2: '类型名称',
        axisName: '任务数',
        unit: '单'
      }),
      getMapMoudle(categoryCustomerCount, {
        targetTitle,
        name: '基层医疗机构',
        axisName2: '地名',
        axisName: '任务数',
        unit: '单'
      }),
      getMoudle(
        detailAddresses.reduce((pre, cur) => {
          pre.push({ d: cur });
          return pre;
        }, []),
        'blank',
        {
          targetTitle,
          moudleTitle: '详细地址'
        }
      ),
      getMoudle(
        hospitalNames.reduce((pre, cur) => {
          pre.push({ d: cur });
          return pre;
        }, []),
        'blank',
        {
          targetTitle,
          moudleTitle: '基层医疗机构名称'
        }
      )
    ];
  },
  // 代理商
  targetType17(info) {
    const {
      targetTitle,
      customerAddressCount,
      customerDomainCount,
      customerTerminalCount,
      targetCount
    } = info;
    return [
      // getCountMoudle(
      //   '代理商',
      //   targetTitle,
      //   customerAddressCount.finalDataCount,
      //   '个'
      // ),
      getMapMoudle(customerAddressCount, {
        targetTitle,
        name: '代理商',
        axisName2: '地名',
        axisName: '数量',
        unit: '个',
        useSpecialCount: true,
        specialCount: targetCount
      }),
      getMoudle(customerDomainCount, 'bar2', {
        targetTitle,
        name: '擅长产品领域',
        moudleTitle: '擅长产品领域',
        axisName2: '领域名称',
        axisName: '数量',
        unit: '个',
        useSpecialCount: true,
        specialCount: targetCount
      }),
      getMoudle(customerTerminalCount, 'line', {
        targetTitle,
        name: '客户终端',
        moudleTitle: '客户终端',
        axisName2: '终端名称',
        axisName: '数量',
        unit: '个',
        useSpecialCount: true,
        specialCount: targetCount
      })
    ];
  }
};
